<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 18:23:36
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2022-10-25 17:54:57
 * @Description: 核心组件，form表单
 -->
<template>
    <div
        class="wg-form-container"
        :class="disabled ? 'disabled-form' : 'enable-form'"
    >
        <a-collapse :bordered="false" v-if="debug">
            <a-collapse-panel header="debug:数据信息" key="1">
                <a-collapse :bordered="false">
                    <a-collapse-panel header="models: 过滤用户value值结果">
                        <pre>models:{{ models }}</pre>
                    </a-collapse-panel>
                </a-collapse>
                <a-collapse :bordered="false">
                    <a-collapse-panel header="fields: 表单设计包含的字段">
                        <pre>fields:{{ fields }}</pre>
                    </a-collapse-panel>
                </a-collapse>
                <a-collapse :bordered="false">
                    <a-collapse-panel header="value: 用户设置表单的值">
                        <pre>value:{{ value }}</pre>
                    </a-collapse-panel>
                </a-collapse>
                <a-collapse :bordered="false">
                    <a-collapse-panel header="rules">
                        <pre>rules:{{ rules }}</pre>
                    </a-collapse-panel>
                </a-collapse>
            </a-collapse-panel>
        </a-collapse>
        <!-- 插槽 -->
        <slot name="header"></slot>

        <a-form :form="form" class="wg-form" ref="dyForm">
            <a-spin
                :spinning="loading"
                tip="Loading...."
                size="large"
                style="display: block; margin: 30px auto"
            >
            </a-spin>
            <wgList :list="jsonData.list" :lang="lang">
                <template
                    v-for="key in Object.keys(formSlots)"
                    v-slot:[key]="slotProps"
                >
                    <slot :name="key" v-bind="slotProps"></slot>
                </template>
            </wgList>
            <!-- 按钮插槽 -->
            <slot name="buttons"></slot>
        </a-form>

        <!-- 插槽 -->
        <slot name="footer"></slot>
    </div>
</template>
<script>
import { addSchemaRule } from '../lib/util';
import { t } from '../locale';

const SUBTABLE_PREFIX = '$__';
export default {
    name: 'wgForm',
    props: {
        debug: {
            type: Boolean,
            default() {
                return false;
            },
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            },
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            },
        },
        // 表单配置数据
        jsonData: {
            type: Object,
            default() {
                return {
                    list: [],
                    config: {},
                };
            },
        },
        // 表单数据
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        // 远程数据获取方法
        remote: {
            type: Object,
            default() {
                return {};
            },
        },
        // 远程数据结构
        dynamic: {
            type: Object,
            default() {
                return {};
            },
        },
        // 自定义的validator集合
        validator: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    // 非常关键，提供给子控件，调用form组织
    provide() {
        return {
            formContext: this,
        };
    },
    data() {
        return {
            // 表单
            models: {},
            // 关键属性：表单包含的字段
            fields: {},
            rules: {},
            // 表单slot
            formSlots: {},
            // 关键属性：子控件
            formItems: {},
            // 存储下拉框远程方法名，支持本地搜索数据
            selectLocalNames: [],
        };
    },
    watch: {
        // 监视数据变更，重新设置值
        value: {
            // upload会触发value内部辩护，暂时先取消deep
            // deep: true,
            // 应用在同步结构和数据中，必须第一次设置数据，但没有数据时，则不执行
            immediate: true,
            handler(val) {
                if (Object.keys(val).length > 0) {
                    this.$nextTick(() => {
                        this.models = this.formatSetValue({ ...val });
                        this.initForm({ ...val });
                    });
                }
            },
        },

        jsonData: {
            deep: true,
            immediate: true,
            handler(val) {
                if (val && val.list) {
                    this.rules = {};
                    // 生成新的规则并且更新
                    this.generateRules(val.list);
                    this.fields = this.generateFields(val.list);
                    // form全局配置
                    this.setConfig(
                        Object.assign(
                            {},
                            {
                                disabled: this.disabled,
                                labelWidth: 100,
                                labelPosition: 'right',
                                size: 'small',
                                customClass: '',
                            },
                            val.config
                        )
                    );
                }
            },
        },
        disabled(val) {
            this.jsonData.config.disabled = val;
            // mutation.updateConfig({ disabled: val });
        },
    },
    computed: {
        formModel() {
            return this.jsonData.config.model;
        },
        // 语言属性从root读取
        lang() {
            if (this.$root.$i18n) {
                return this.$root.$i18n.locale.replace('-', '_');
            }
            return process.env.VUE_APP_DEFAULT_LANG;
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, {
            name: 'dy',
        });
    },

    mounted() {},

    methods: {
        t(...args) {
            return t.apply(this, args);
        },
        setSelectLocalNames(value) {
            this.selectLocalNames = value;
        },
        previewURL(url, name) {
            return `${url}?fileName=${encodeURIComponent(name)}`;
        },
        downloadURL(url, name) {
            return `${url}?fileName=${encodeURIComponent(name)}`;
        },
        // 初始化赋值子表数据
        initSubTable(value) {
            // 取出子表字段
            const newValue = {};
            Object.keys(value).forEach((key) => {
                if (key.startsWith(SUBTABLE_PREFIX)) {
                    newValue[key] = value[key];
                }
            });
            // 设置部署字段，仅子表辅助字段
            this.form.setFieldsValue(newValue);
        },
        initForm(value) {
            // 将外部用户数据，赋值到表单
            this.$nextTick(() => {
                this.setFieldsValue(value);
            });
        },

        /**
         * 提供外部API: 验证表单，返回校验过数据
         */
        validate() {
            return new Promise((resolve, reject) => {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        resolve({
                            [this.formModel]: this.formatGetValue(values),
                        });
                    } else {
                        reject(err);
                    }
                });
            });
        },

        /**
         * 提供外部API: 仅验证表单
         * form.validateFields(['nickname'], { force: true });
         */
        validateFields(...args) {
            return this.form.validateFields(...args);
        },

        /**
         * 提供外部API: 获取表单值，不校验
         */
        getData() {
            // TODO：获取值
            return { [this.formModel]: this.getFieldsValue() };
        },

        /**
         * form原始属性getFieldValue
         */
        getFieldValue(fieldName) {
            return this.form.getFieldValue(fieldName);
        },

        /**
         * 提供外部API: 重置表单，
         */
        reset() {
            this.form.resetFields();
        },

        // 子表字段无数据时，是获取不到数据的，需要新建属性与初始化为空数组
        formatGetValue(value) {
            const newValue = {};
            Object.keys(value).forEach((key) => {
                if (key.startsWith(SUBTABLE_PREFIX)) {
                    if (value[key].length === 0) {
                        // 新增真正子表属性名
                        newValue[key.replace(SUBTABLE_PREFIX, '')] = [];
                    }
                } else {
                    newValue[key] = value[key];
                }
            });
            // 将子表数据处理后结果返回
            return newValue;
        },

        /**
         * 用户给表单设置的中value,必须处理后才能赋值给表单，同时也将date和time类型转换为moment格式
         */
        formatSetValue(value, fields = this.fields) {
            const newValue = {};
            const valueKeys = Object.keys(value);
            valueKeys.forEach((key) => {
                // 数据value中的key是否在fields 中存在
                const field = fields[key];

                // biz_it_office_resource_application_detailList[0].other
                const tableIndex = key.indexOf('[');
                const fieldIndex = key.indexOf('].');
                if (tableIndex > -1) {
                    const tableKey = key.substr(0, tableIndex);
                    const fieldKey = key.substr(fieldIndex + 2);
                    // 如果 tableKey与fieldKey 都符合，则可以给表单赋值
                    if (fields[tableKey]) {
                        const checkValue = this.formatSetValue(
                            { [fieldKey]: value[key] },
                            fields[tableKey].subFields
                        );
                        // 如果返回存在对象，则说明 fieldKey 在字表中是合法的，存在其key,那么值有效
                        if (
                            Object.prototype.hasOwnProperty.call(
                                checkValue,
                                fieldKey
                            )
                        ) {
                            newValue[key] = value[key];
                        }
                    }
                } else if (field) {
                    // value中存在属性key
                    const originVal = value[key];
                    // 如果是子表字段，则originVal是数组
                    if (field.type === 'table') {
                        if (originVal) {
                            // 过滤每一行数据中的每列
                            newValue[key] = originVal.map((item) =>
                                this.formatSetValue(item, field.subFields)
                            );
                            newValue[`${SUBTABLE_PREFIX}${key}`] = newValue[
                                key
                            ].map((item, index) => ({ ...item, key: index }));
                        }
                    } else {
                        // 非子表字段，拷贝值
                        newValue[key] = originVal;
                    }
                }
            });
            return newValue;
        },

        /**
         * 提供外部API: 设置表单值
         */
        setFieldsValue(val, noCheck = false) {
            // 如果不检查数据，则直接设置，但要开发人员确保字段已存在，且非子表字段
            // 目的是加速，跳过 formatSetValue 函数不必要的检查
            if (noCheck) {
                this.form.setFieldsValue(val);
            } else {
                // val中的字段，表单中可能不存在，可能需要一个字表辅助字段$key__,因此先修正val
                let values = this.formatSetValue({ ...val });
                // 修正后，先初始化子表单
                this.initSubTable(values);
                // 在初始化其他的字段
                this.$nextTick(() => {
                    this.form.setFieldsValue(values);
                });
            }
        },

        /**
         * 提供外部API: 获取表单值
         */
        getFieldsValue(fieldNames = [], noCheck = false) {
            if (noCheck) {
                if (fieldNames.length > 0) {
                    const value = this.form.getFieldsValue();
                    return value;
                }
                const value = this.form.getFieldsValue(fieldNames);
                return value;
            }
            // 获取所有字段的数据
            const value = this.formatGetValue(this.form.getFieldsValue());
            // 移除掉子表单赋值字段值
            if (fieldNames.length > 0) {
                const newValue = {};
                fieldNames.forEach((key) => {
                    newValue[key] = value[key];
                });
                return newValue;
            }
            return value;
        },

        getWidgetRule(widget) {
            const copyRules = [];
            widget.rules.forEach((item) => {
                copyRules.push({ ...item });
            });
            copyRules
                ?.filter((item) => item.validator)
                .forEach((item) => {
                    // 重新validator，修正为函数
                    /* eslint-disable */
                    item.cusValidator = item.validator;
                    item.validator = this.validator[item.validator];
                    /* eslint-enable */
                });
            const rules = {
                rules: [...copyRules],
            };
            if (widget.options.defaultValue) {
                rules.initialValue = widget.options.defaultValue;
            }
            return rules;
        },

        generateRules(genList = []) {
            //
            for (let i = 0; i < genList.length; i += 1) {
                const widget = genList[i];
                const { type, model } = widget;
                if (type === 'grid') {
                    widget.columns.forEach((item) => {
                        this.generateRules(item.list);
                    });
                } else if (type === 'card') {
                    this.generateRules(widget.list);
                } else if (type === 'tabs') {
                    widget.tabs.forEach((item) => {
                        this.generateRules(item.list);
                    });
                } else if (type === 'table') {
                    this.rules[model] = this.getWidgetRule(widget);
                    // 表格有slot
                    this.formSlots[model] = model;
                    this.formSlots[`${model}_footer`] = `${model}_footer`;
                    this.generateRules(widget.tableColumns);
                } else if (type === 'blank') {
                    // blank有slot
                    this.formSlots[model] = model;
                    this.rules[model] = this.getWidgetRule(widget);
                } else {
                    this.rules[model] = this.getWidgetRule(widget);
                }
            }
            //
        },

        /**
         * 根据配置，生成字段关系
         */
        generateFields(genList = []) {
            const fields = {};
            for (let i = 0; i < genList.length; i += 1) {
                const widget = genList[i];
                const {
                    type,
                    model,
                    options: { defaultValue, hidden, multiple },
                } = widget;
                if (!hidden) {
                    if (type === 'grid') {
                        widget.columns.forEach((item) => {
                            const gridFields = this.generateFields(item.list);
                            Object.keys(gridFields).forEach((key) => {
                                fields[key] = gridFields[key];
                            });
                        });
                    } else if (type === 'card') {
                        const cardFields = this.generateFields(widget.list);
                        Object.keys(cardFields).forEach((key) => {
                            fields[key] = cardFields[key];
                        });
                    } else if (type === 'tabs') {
                        widget.tabs.forEach((item) => {
                            const tabsFields = this.generateFields(item.list);
                            Object.keys(tabsFields).forEach((key) => {
                                fields[key] = tabsFields[key];
                            });
                        });
                    } else if (type === 'table') {
                        fields[model] = {
                            defaultValue,
                            model,
                            type,
                            subFields: {},
                        };
                        // 非常重要：子表辅助字段
                        fields[`${SUBTABLE_PREFIX}${model}`] = {
                            defaultValue: defaultValue.map((item, index) => ({
                                key: index,
                            })),
                            model: `${SUBTABLE_PREFIX}${model}`,
                            type,
                        };
                        const tableFields = this.generateFields(
                            widget.tableColumns
                        );
                        Object.keys(tableFields).forEach((key) => {
                            fields[model].subFields[key] = tableFields[key];
                        });
                    } else {
                        fields[model] = {
                            defaultValue,
                            model,
                            type,
                            multiple,
                        };
                    }
                }
            }
            //
            return fields;
        },

        // 更新部件 options 属性
        updateFieldOptions(widgetField, { key, value }, responsive = false) {
            function updateRules(rules, name, val) {
                let result = [];
                if (val) {
                    const otherRules = rules?.filter(
                        (item) =>
                            !Object.prototype.hasOwnProperty.call(
                                item,
                                'required'
                            )
                    );
                    // `${name}必须填写`
                    result = [
                        {
                            required: true,
                            message: this.t('wg.required', [name]),
                        },
                        ...otherRules,
                    ];
                } else {
                    const otherRules = rules?.filter(
                        (item) =>
                            !Object.prototype.hasOwnProperty.call(
                                item,
                                'required'
                            )
                    );
                    result = [
                        {
                            required: false,
                            message: this.t('wg.required', [name]),
                        },
                        ...otherRules,
                    ];
                }
                return result;
            }
            // 暂存，响应式函数
            let set;
            if (responsive) {
                set = this.$set;
            }

            function updateField(findField, genList) {
                const arrField = findField.split('.');
                const field = arrField[arrField.length - 1];
                const parentField = arrField
                    .slice(0, arrField.length - 1)
                    .join('.');
                for (let i = 0; i < genList.length; i += 1) {
                    const widget = genList[i];
                    const { type, model, name } = widget;
                    if (model === field) {
                        if (responsive) {
                            // 响应式更新，主要是 widget.options 中为存在的属性，不会被监视导致的无法更新问题
                            set(widget.options, key, value);
                        } else {
                            widget.options[key] = value;
                        }
                        // 如果是required属性，修正rules
                        if (key === 'required') {
                            widget.rules = updateRules(
                                widget.rules,
                                name,
                                value
                            );
                        }
                    }
                    if (type === 'grid') {
                        widget.columns.forEach((item) => {
                            updateField(findField, item.list);
                        });
                    } else if (type === 'card') {
                        updateField(findField, widget.list);
                    } else if (type === 'tabs') {
                        widget.tabs.forEach((item) => {
                            updateField(findField, item.list);
                        });
                    } else if (type === 'table') {
                        if (parentField === widget.model) {
                            updateField(field, widget.tableColumns);
                        }
                    }
                }
            }
            updateField(widgetField, this.jsonData.list);
        },

        /**
         *
         */
        setFieldsOptions(fields, { key, value }) {
            fields.forEach((field) => {
                this.updateFieldOptions(field, { key, value });
            });
            this.fields = this.generateFields(this.jsonData.list);
        },

        /**
         * v-if 控制 显示一组字段，父显示，子节点不受控制
         */
        showFields(fields) {
            fields.forEach((field) => {
                this.updateFieldOptions(field, { key: 'hidden', value: false });
            });
            this.fields = this.generateFields(this.jsonData.list);
        },
        /**
         * v-if 控制 隐藏一组字段，父隐藏，则子节点也隐藏，直接不渲染
         */
        hideFields(fields) {
            fields.forEach((field) => {
                this.updateFieldOptions(field, { key: 'hidden', value: true });
            });
            this.fields = this.generateFields(this.jsonData.list);
        },

        /**
         * 描述 v-show 控制 显示和隐藏
         * @date 2021-08-03
         * @param {any} fields 操作的字段数组
         * @param {any} val 显示true,隐藏false
         * @returns {any}
         */
        visibleFields(fields, val) {
            fields.forEach((field) => {
                this.updateFieldOptions(
                    field,
                    { key: 'visible', value: val },
                    true
                );
            });
            this.fields = this.generateFields(this.jsonData.list);
        },

        /**
         * 禁用一组字段，父禁用，则节点不受制影响
         */
        enableFields(fields) {
            fields.forEach((field) => {
                if (this.formItems[field]) {
                    this.formItems[field].setReadOnly(false);
                } else {
                    this.setTableField(field, false, 'disabled');
                }
            });
        },
        /**
         * 禁用一组字段，父禁用，则节点不受制影响
         */
        disabledFields(fields) {
            fields.forEach((field) => {
                if (this.formItems[field]) {
                    this.formItems[field].setReadOnly(true);
                } else {
                    this.setTableField(field, true, 'disabled');
                }
            });
        },

        /**
         * 设置组件实例实时验证属性
         */
        requiredFields(fields, val) {
            fields.forEach((field) => {
                if (this.formItems[field]) {
                    this.formItems[field].setRequired(val);
                } else {
                    this.setTableField(field, val, 'required');
                }
            });
        },

        setTableField(field, val, name) {
            if (typeof field === 'string') {
                const [parentField, subField] = field.split('.');
                if (parentField && subField) {
                    const parentWidget = this.formItems[parentField];
                    if (parentWidget) {
                        const subWidget = parentWidget.widget.tableColumns.find(
                            (col) => col.model === subField
                        );
                        if (subWidget) {
                            subWidget.options[name] = val;
                        }
                    }
                }
            } else if (typeof field === 'object') {
                Object.keys(field).forEach((parentField) => {
                    const parentWidget = this.formItems[parentField];
                    if (parentWidget) {
                        field[parentField].forEach((subField) => {
                            const subWidget =
                                parentWidget.widget.tableColumns.find(
                                    (col) => col.model === subField
                                );
                            if (subWidget) {
                                subWidget.options[name] = val;
                            }
                        });
                    }
                });
            }
        },
        /**
         * 增加数据校验器规则，为了删除和更新，给规则设置 ruleId
         */
        addRule(field, ruleId, rule) {
            if (this.formItems[field]) {
                this.formItems[field].addRule(ruleId, rule);
            }
        },
        /**
         * 删除数据校验器规则
         */
        removeRule(field, ruleId) {
            if (this.formItems[field]) {
                this.formItems[field].removeRule(ruleId);
            }
        },
        /**
         * 增加子表数据校验器规则，为了删除和更新，给规则设置 ruleId
         */
        addTableRule(field, ruleId, rule) {
            const [parentField, subField] = field.split('.');
            if (this.formItems[parentField]) {
                this.formItems[parentField].widget.tableColumns.forEach(
                    (item) => {
                        if (item.model === subField) {
                            addSchemaRule(item.rules, ruleId, rule);
                        }
                    }
                );
            }
        },

        /**
         * 删除子表数据校验器规则
         */
        removeTableRule(field, ruleId) {
            if (this.formItems[field]) {
                this.formItems[field].removeRule(ruleId);
            }
        },

        updateFieldRules(field, rules) {
            this.rules[field].rules = rules;
        },
        // 设置表单全局配置
        setConfig(config) {
            Object.keys(config).forEach((key) => {
                this.jsonData.config[key] = config[key];
            });
        },
    },
};
// 国际化触达文件
</script>
